import { useState } from 'react';
import CompanySettingsData from '../models/company-settings-data.model';

// Holds the whole company settings object (not just decimalSeparator) so any consumer that later needs
// another field (photo, companySales, layoutType, ...) can read it from the same shared cache instead of
// adding its own narrow fetch.
export const CompanySettingsUseBetween = () => {
    const [companySettings, setCompanySettings] = useState<CompanySettingsData>({});
    return {
        companySettings,
        setCompanySettings,
    };
};
